// ✅ DOIT ÊTRE EN PREMIER - Polyfills pour Safari
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './services/supabase'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Courses from './pages/Courses'  // Changé de Sessions à Courses
import CheckinName from './pages/CheckinName'
import CheckinQR from './pages/CheckinQR'
import Reports from './pages/Reports'
import Members from './pages/Members'
import NotFound from './pages/NotFound'
import CompleteProfile from './pages/CompleteProfile'
import RegisterCoach from './pages/RegisterCoach'
import Coaches from './pages/Coaches'
import CheckinCoachName from './pages/CheckinCoachName'
import CheckinCoachQR from './pages/CheckinCoachQR'

function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser()
      setUser(user)
      setLoading(false)
    }

    getUser()

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
      setLoading(false)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={!user ? <Login /> : <Navigate to="/" replace />} 
      />
      <Route path="/register" element={<Register />} /> 
       <Route path="/complete-profile" element={<CompleteProfile />} />
      <Route 
        path="/" 
        element={user ? <Dashboard user={user} /> : <Navigate to="/login" replace />} 
      />
      <Route 
        path="/courses"  // Changé de /sessions à /courses
        element={user ? <Courses /> : <Navigate to="/login" replace />} 
      />
      <Route 
        path="/checkin/name/:sessionId" 
        element={user ? <CheckinName /> : <Navigate to="/login" replace />} 
      />
      <Route 
        path="/checkin/qr/:sessionId" 
        element={user ? <CheckinQR /> : <Navigate to="/login" replace />} 
      />
      <Route 
        path="/members" 
        element={user ? <Members /> : <Navigate to="/login" replace />} 
      />
      <Route 
        path="/reports" 
        element={user ? <Reports /> : <Navigate to="/login" replace />} 
      />
      <Route path="/register-coach" element={<RegisterCoach />} />
      <Route path="/coaches" element={user ? <Coaches /> : <Navigate to="/login" replace />} />

      <Route path="/checkin/coach-name/:sessionId" element={user ? <CheckinCoachName /> : <Navigate to="/login" replace />} />
<Route path="/checkin/coach-qr/:sessionId"  element={user ? <CheckinCoachQR />  : <Navigate to="/login" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App